/* eslint-disable jira/filename-case */
// Source: https://github.com/atlassian/react-beautiful-dnd
type Overflow = {
	overflowX: string;
	overflowY: string;
};

const isEqual =
	(base: string) =>
	(value: string): boolean =>
		base === value;
const isScroll = isEqual('scroll');
const isAuto = isEqual('auto');
const isEither = (overflow: Overflow, fn: (value: string) => boolean) =>
	fn(overflow.overflowX) || fn(overflow.overflowY);

const isElementScrollable = (el: Element): boolean => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const style: CSSStyleDeclaration = window.getComputedStyle(el);
	const overflow: Overflow = {
		overflowX: style.overflowX,
		overflowY: style.overflowY,
	};

	return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

export const getClosestScrollableElement = (el?: Element | null): Element | null => {
	if (!el) {
		return null;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (el === document.body || el === document.documentElement) {
		return null;
	}

	if (!isElementScrollable(el)) {
		return getClosestScrollableElement(el.parentElement);
	}

	return el;
};
